"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookClientInt = bookClientInt;
exports.bookClientString = bookClientString;
function bookClientInt(res) {
  if (typeof res === "number") {
    return res;
  }
  if (typeof res === "string") {
    let num = parseInt(res);
    if (!isNaN(num)) {
      return num;
    }
  }
  return null;
}
function bookClientString(res) {
  if (typeof res === "string") {
    return res;
  }
  if (typeof res === "number") {
    return res.toString();
  }
  return null;
}
//# sourceMappingURL=BookClient.js.map